import {
  FilterHdr,
  LocalBar,
  LocalDining,
  LocalMall,
  Museum,
  NaturePeople,
  Spa,
} from "@material-ui/icons";
const tags = [
  { Icon: Museum, name: "Museum" },
  { Icon: FilterHdr, name: "Outdoors" },
  { Icon: NaturePeople, name: "Wildlife" },
  { Icon: LocalMall, name: "Shopping" },
  { Icon: LocalDining, name: "Restaurant" },
  { Icon: LocalBar, name: "Nightlife" },
  { Icon: Spa, name: "Spa" },
];
export default tags;
